import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StringCutterPipe } from './string-cutter.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { UTCDatePipe } from './utc-date.pipe';
import { TimeDurationPipe, TimeRangePipe } from './time-line.pipe';

@NgModule({
  declarations: [
    SafeHtmlPipe,
    StringCutterPipe,
    UTCDatePipe,
    TimeRangePipe,
    TimeDurationPipe,
  ],
  imports: [CommonModule],
  exports: [
    SafeHtmlPipe,
    StringCutterPipe,
    UTCDatePipe,
    TimeRangePipe,
    TimeDurationPipe,
  ],
})
export class CustomPipesModule {}
